var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter } from '@angular/core';
import { CommunicationService } from '../../../services/communication.service';
import { ViewModes, ListingCategory } from '../../../classes/enums';
import { HasSubscriptions } from '../../has-subscriptions';
var SubNavComponent = /** @class */ (function (_super) {
    __extends(SubNavComponent, _super);
    function SubNavComponent(communicationService) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this.activeViewMode = ViewModes.MAP;
        _this.filterClick = new EventEmitter();
        _this.saveSearchClick = new EventEmitter();
        _this.viewModeClick = new EventEmitter();
        _this.showShare = false;
        _this.showSearch = false;
        // Enums:
        _this.ViewModes = ViewModes;
        _this.ListingCategory = ListingCategory;
        return _this;
    }
    SubNavComponent.prototype.ngOnInit = function () {
        var _this = this;
        // reacts to when the user clicks on the button to hide the search bar
        this.addSub(this.communicationService.navigation.showSearch.subscribe(function (showSearch) {
            _this.showSearch = showSearch;
        }));
    };
    SubNavComponent.prototype.toSearch = function () {
        this.showSearch = !this.showSearch;
        this.communicationService.navigation.showSearch.next(this.showSearch);
    };
    return SubNavComponent;
}(HasSubscriptions));
export { SubNavComponent };
